module.exports = __webpack_public_path__ + "img/low-risk.cf6dbd11.png";